class ShowMore {
  constructor() {
    // Prevent multiple instances
    if (window.ShowMoreInstance) {
      return window.ShowMoreInstance;
    }
    window.ShowMoreInstance = this;
    this.init();
  }

  init() {
    const productGrids = document.querySelectorAll('.product-grid');
    productGrids.forEach(grid => {
      const products = grid.querySelectorAll('.grid__item');
      const mobileThreshold = parseInt(grid.dataset.mobileThreshold) || 4;
      const desktopThreshold = parseInt(grid.dataset.desktopThreshold) || 8;
      
      // Read layout once before writing styles to avoid forced reflow
      const isMobileInit = window.innerWidth < 750;
      const threshold = isMobileInit ? mobileThreshold : desktopThreshold;
      products.forEach((product, index) => {
        if (index >= threshold) {
          product.style.display = 'none';
        }
      });
    });

    // Handle window resize (debounced to avoid forced reflows).
    //
    // IMPORTANT: only re-evaluate when the mobile/desktop BREAKPOINT actually
    // changes (i.e. the viewport WIDTH crosses 750px). On mobile browsers,
    // scrolling shows/hides the address bar, which changes the viewport HEIGHT
    // and fires a `resize` event with the width unchanged. Re-running the
    // collapse logic on those height-only events used to hide every product the
    // shopper had just revealed via "Show Full Range" — so a scroll down/up made
    // the socks disappear. Bailing when the width is unchanged prevents that.
    let resizeTimer;
    let lastWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
      const currentWidth = window.innerWidth;
      if (currentWidth === lastWidth) return; // height-only change (mobile address bar) — ignore
      lastWidth = currentWidth;
      productGrids.forEach(grid => {
        const products = grid.querySelectorAll('.grid__item');
        const mobileThreshold = parseInt(grid.dataset.mobileThreshold) || 4;
        const desktopThreshold = parseInt(grid.dataset.desktopThreshold) || 8;
        const threshold = currentWidth < 750 ? mobileThreshold : desktopThreshold;
        // The live "Show Full Range" control is OptimizedProductGrid's
        // .show-more-products / .show-less-products button (in main-collection-
        // product-grid.liquid). When the shopper has expanded the range, a
        // .show-less-products button is present and/or AJAX-appended
        // .dynamically-loaded cards exist — never collapse those away.
        const showMoreButton = grid.parentNode.querySelector('.show-more-button, .show-more-products');
        const expanded = !!grid.parentNode.querySelector('.show-less-products') ||
          !!grid.querySelector('.grid__item.dynamically-loaded') ||
          (showMoreButton && showMoreButton.getAttribute('data-expanded') === 'true');
        if (expanded) {
          // If expanded, keep every product visible
          products.forEach(product => {
            product.style.display = '';
          });
          if (showMoreButton) {
            showMoreButton.setAttribute('data-expanded', 'true');
          }
        } else {
          // If not expanded, collapse to the current breakpoint's threshold
          products.forEach((product, index) => {
            if (index < threshold) {
              product.style.display = '';
            } else {
              product.style.display = 'none';
            }
          });
          if (showMoreButton) {
            showMoreButton.setAttribute('data-expanded', 'false');
            showMoreButton.style.display = products.length > threshold ? '' : 'none';
          }
        }
      });
      }, 150);
    });
  }

  handleShowMore(products, button, grid) {
    const isMobile = window.innerWidth < 750;
    const threshold = isMobile ? 
      parseInt(products[0].closest('.product-grid').dataset.mobileThreshold) || 4 :
      parseInt(products[0].closest('.product-grid').dataset.desktopThreshold) || 8;
    // Check if currently expanded
    const expanded = button.getAttribute('data-expanded') === 'true';
    if (!expanded) {
      // Show all products
      products.forEach(product => {
        product.style.display = '';
      });
      button.textContent = 'Show Less';
      button.setAttribute('data-expanded', 'true');
      grid.setAttribute('data-show-more-expanded', 'true');
    } else {
      // Collapse to threshold
      products.forEach((product, index) => {
        if (index < threshold) {
          product.style.display = '';
        } else {
          product.style.display = 'none';
        }
      });
      button.textContent = 'Show More';
      button.setAttribute('data-expanded', 'false');
      grid.setAttribute('data-show-more-expanded', 'false');
    }
  }
}

// Only define custom element if not already defined
if (!customElements.get('show-more')) {
  customElements.define('show-more', class extends HTMLElement {
    connectedCallback() {
      new ShowMore();
    }
  });
}

// Initialize only once when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.ShowMoreInstance) {
      new ShowMore();
    }
  });
} else {
  if (!window.ShowMoreInstance) {
    new ShowMore();
  }
}
